import React from "react";
import Switch from "react-switch";

export default function CobeeSwitch(props) {
  return (
    <Switch
      {...props}
      onColor="#0000ff"
      offColor="#c4c4c4"
      uncheckedIcon={false}
      checkedIcon={false}
      boxShadow="0px 3pt 6pt 0px rgba(0, 0, 0, 0.3), 0px 2pt 2pt 0px rgba(0, 0, 0, 0.02), 0px 2pt 1pt 0px rgba(0, 0, 0, 0.05)"
      activeBoxShadow="0px 3pt 6pt 0px rgba(0, 0, 0, 0.3)"
      width={42}
      height={27}
      handleDiameter={23}
    />
  );
}
